// extracted by mini-css-extract-plugin
export default {"layoutSelectorDialogContainer":"_layout-selector-dialog_layoutSelectorDialogContainer__pXnmz","description":"_layout-selector-dialog_description__obnUw"};